import axios from 'axios';
import url from '../url.js';

/**
 * 創建新範本
 */
export const createActivityTemplate = async (templateData) => {
  try {
    const response = await axios.post(
      `${url.backendHost}api/activity-templates`,
      templateData,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating template:', error);
    throw new Error(error.response?.data?.message || '創建範本失敗');
  }
};

/**
 * 獲取用戶的所有範本
 */
export const getUserTemplates = async (userId) => {
  try {
    const response = await axios.get(
      `${url.backendHost}api/activity-templates/user/${userId}`,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching user templates:', error);
    throw new Error(error.response?.data?.message || '獲取範本列表失敗');
  }
};

/**
 * 根據 ID 獲取範本詳情
 */
export const getTemplateById = async (id, requestUserId = null) => {
  try {
    const response = await axios.get(
      `${url.backendHost}api/activity-templates/${id}`,
      { 
        withCredentials: true,
        data: requestUserId ? { requestUserId } : {}
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching template:', error);
    throw new Error(error.response?.data?.message || '獲取範本詳情失敗');
  }
};

/**
 * 更新範本
 */
export const updateActivityTemplate = async (id, templateData) => {
  try {
    const response = await axios.put(
      `${url.backendHost}api/activity-templates/${id}`,
      templateData,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating template:', error);
    throw new Error(error.response?.data?.message || '更新範本失敗');
  }
};

/**
 * 刪除範本
 */
export const deleteActivityTemplate = async (id, userId) => {
  try {
    const response = await axios.delete(
      `${url.backendHost}api/activity-templates/${id}`,
      { 
        withCredentials: true,
        data: { userId }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting template:', error);
    throw new Error(error.response?.data?.message || '刪除範本失敗');
  }
};

/**
 * 獲取所有公開範本
 */
export const getPublicTemplates = async () => {
  try {
    const response = await axios.get(
      `${url.backendHost}api/activity-templates/public`,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching public templates:', error);
    throw new Error(error.response?.data?.message || '獲取公開範本列表失敗');
  }
};
